import { BugOutlined, HomeOutlined, ReloadOutlined } from '@ant-design/icons';
import React from 'react';
import { Button, Layout, Result, Typography } from 'zui/Antd';

const { Content } = Layout;
const { Paragraph, Text } = Typography;

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error('Error caught by ErrorBoundary:', error, errorInfo);
		// You can send this error info to a logging service here
	}

	handleRetry = () => {
		this.setState({ hasError: false, error: null });
		window.location.reload(); // Optionally reload the page
	};

	render() {
		if (this.state.hasError) {
			return (
				<Layout style={{ height: '100vh', display: 'grid', placeItems: 'center', backgroundColor: '#f0f2f5' }}>
					<Content>
						<Result
							status='error'
							title='Oops! Something Went Wrong'
							icon={<BugOutlined style={{ fontSize: 50, color: 'red' }} />}
							subTitle={
								<Paragraph>
									An unexpected error occurred.
									{this.state.error && <Text type='danger'> {this.state.error.toString()} </Text>}
									Please try again or return to the home page.
								</Paragraph>
							}
							extra={[
								<Button key='retry' type='primary' icon={<ReloadOutlined />} onClick={this.handleRetry}>
									Retry
								</Button>,
								<Button key='home' icon={<HomeOutlined />} href='/'>
									Go Home
								</Button>
							]}
						/>
					</Content>
				</Layout>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
